import React from 'react';
import IconButton from '@frontend/Components/Inputs/IconButton';
import type { ButtonElement as ButtonElementType } from '@frontend/Models/TopBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './ButtonElement.css';

/**
 * ButtonElement - Wrapper around IconButton for TopBar
 *
 * This component wraps the existing IconButton component and adds
 * conditional rendering support for the UnifiedTopBar configuration system.
 *
 * @param props - ButtonElement configuration from TopBar
 */
const ButtonElement: React.FC<ButtonElementType> = ({
  icon,
  onClick,
  ariaLabel,
  label,
  style,
  disabled = false,
  tooltip,
  condition,
}) => {
  // Handle conditional rendering
  if (condition && !condition()) {
    return null;
  }

  // If a visible label is provided, render a text+icon button so the
  // button text is visible to users (not only as an aria label).
  if (label) {
    return (
      <button
        type="button"
        className="topBar-text-button"
        aria-label={ariaLabel}
        onClick={onClick}
        style={style}
        disabled={disabled}
        title={tooltip}
      >
        <FontAwesomeIcon icon={icon} className="topBar-text-button__icon" />
        <span className="topBar-text-button__label">{label}</span>
      </button>
    );
  }

  return (
    <IconButton
      icon={icon}
      onClick={onClick}
      ariaLabel={ariaLabel}
      style={style}
      disabled={disabled}
      title={tooltip}
      className="topBar-button-element"
    />
  );
};

export default ButtonElement;
